import Phaser from 'phaser';
import { Button } from '../ui/Button';
import { Toast } from '../ui/Toast';
import { AIDifficulty } from '../core/types';
import { EconomySystem } from '../systems/EconomySystem';
import { ProgressionSystem } from '../systems/ProgressionSystem';

export class MenuScene extends Phaser.Scene {
  constructor() {
    super('MenuScene');
  }

  create() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Background
    const bg = this.add.graphics();
    bg.fillGradientStyle(0x1a3a2a, 0x1a3a2a, 0x0a1f14, 0x0a1f14, 1);
    bg.fillRect(0, 0, width, height);

    // Particles
    const particles = this.add.particles(0, 0, 'particle_gold', {
        x: { min: 0, max: width },
        y: { min: 0, max: height },
        speed: { min: 10, max: 20 },
        angle: { min: 0, max: 360 },
        scale: { start: 0.5, end: 0 },
        alpha: { start: 0.5, end: 0 },
        lifespan: 5000,
        frequency: 200,
        blendMode: 'ADD'
    });

    // Title
    const title = this.add.text(width / 2, height / 4, 'ZENTRYX', {
        fontSize: '72px',
        fontFamily: 'Arial',
        fontStyle: 'bold',
        color: '#d4af37',
        shadow: { offsetX: 2, offsetY: 2, color: '#000000', blur: 5, fill: true }
    }).setOrigin(0.5);

    const subtitle = this.add.text(width / 2, height / 4 + 60, 'D O M I N Ó', {
        fontSize: '24px',
        fontFamily: 'Arial',
        color: '#ffffff',
        letterSpacing: 10
    }).setOrigin(0.5);

    // Title float animation
    this.tweens.add({
        targets: [title, subtitle],
        y: '+=10',
        duration: 2000,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.inOut'
    });

    // Stats
    const coins = EconomySystem.getInstance().getCoins();
    const level = ProgressionSystem.getInstance().getLevel();
    
    this.add.text(20, 20, `Nivel: ${level} | Monedas: ${coins}`, {
        fontSize: '18px',
        color: '#d4af37'
    });

    // Difficulty buttons container
    const difficultyContainer = this.add.container(width / 2, height / 2 + 100);
    difficultyContainer.setVisible(false);

    const btnEasy = new Button(this, -150, 0, 120, 50, 'Fácil', 'primary', () => {
        this.scene.start('GameScene', { difficulty: AIDifficulty.Easy });
    });
    const btnMed = new Button(this, 0, 0, 120, 50, 'Medio', 'primary', () => {
        this.scene.start('GameScene', { difficulty: AIDifficulty.Medium });
    });
    const btnHard = new Button(this, 150, 0, 120, 50, 'Difícil', 'primary', () => {
        this.scene.start('GameScene', { difficulty: AIDifficulty.Hard });
    });

    difficultyContainer.add([btnEasy, btnMed, btnHard]);

    // Main buttons
    const btnPlay = new Button(this, width / 2, height / 2, 200, 60, '🎮 JUGAR', 'primary', () => {
        difficultyContainer.setVisible(true);
        btnPlay.setVisible(false);
        btnShop.setVisible(false);
        btnOnline.setVisible(false);
    });

    const btnShop = new Button(this, width / 2, height / 2 + 80, 200, 60, '🛒 TIENDA', 'secondary', () => {
        Toast.show(this, 'Tienda no disponible');
    });

    const btnOnline = new Button(this, width / 2, height / 2 + 160, 200, 60, '🌐 ONLINE', 'secondary', () => {
        Toast.show(this, 'Próximamente');
    });

    this.add.existing(btnPlay);
    this.add.existing(btnShop);
    this.add.existing(btnOnline);
  }
}
